import { DropdownMenu } from "@kobalte/core";
import { keyframes, styled } from "solid-styled-components";

const contentShow = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const contentHide = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.96);
  }
`;

export const DropdownMenuContent = styled(DropdownMenu.Content)`
  border-radius: 10px;
  user-select: none;
  z-index: 64;
  ${({ theme }) => `
	background: ${theme?.colors.foreground};
	box-shadow: ${theme?.shadows.big};
  color: ${theme?.colors.color};
  `};
  transform-origin: var(--kb-menu-content-transform-origin);
  animation: ${contentHide} 250ms ease-in forwards;
  max-height: 200px;
  overflow-y: auto;

  &:is([data-expanded]) {
    transform-origin: var(--kb-menu-content-transform-origin);
    animation: ${contentShow} 250ms ease-in forwards;
  }
`;
export const DropdownMenuTrigger = styled(DropdownMenu.Trigger)`
  border: none;
  background: none;
  cursor: pointer;
`;

export const DropdownMenuItem = styled(DropdownMenu.Item)`
  user-select: none;
  min-height: 50px;
  gap: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme?.colors.accentQuinary};
  }
`;
